import React from "react";
import "../assets/css/About.css";
import "../assets/css/Contact.css";


import bannerImg from "../assets/images/about/banner.jpg";

const AboutBanner = () => {
  return (
    <div
      className="contact-hero"
      style={{
        backgroundImage: `url(${bannerImg})`,
      }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col">
            <div className="banner-heading text-center">
              <h1 className="contact-title">About Us</h1>

             
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutBanner;